/** A short tap on phones that support it (Android). No-op elsewhere. */
export function tap(): void {
  try {
    navigator.vibrate?.(10);
  } catch {
    // Some browsers throw when vibrate is blocked: ignore.
  }
}
